import { Pipe, PipeTransform } from '@angular/core';
import { TolgeeService } from '@core/translation/tolgee.service';

/**
 * Resolves `types.units.<id>.name` / `.note` from a base key such as `types.units.kwh`
 * (matches nested structure in translations/de.json under types.units).
 */
@Pipe({
    name: 'unitTypesField',
    standalone: false
})
export class UnitTypesFieldPipe implements PipeTransform {
    constructor(private _tolgee: TolgeeService) {}

    transform(translationKey: string | null | undefined, field: 'name' | 'note' = 'name'): string {
        if (!translationKey) {
            return '';
        }
        return this._tolgee.translate(`${translationKey}.${field}`);
    }
}
